<template>
  <div class="need-content margin-general">
    <div class="need-image">
      <img :src="imageSrc" :alt="imageAlt" />
    </div>
    <div class="need-text-content">
      <h2>
        {{ $t("trading.need-account.title") }}
      </h2>
      <p class="need-sub-title body-4">
        {{ $t("trading.need-account.subTitle") }} <br/>
        {{ $t("trading.need-account.subTitle2") }}
      </p>
      <NuxtLink :to="localPath('/trading/accounts/')" class="second-button-medium body-6-bold">
          {{ $t("trading.need-account.btn") }}
      </NuxtLink>
    </div>
    <NuxtLink :to="localPath('/trading/accounts/')" class="second-button-extrasmall">
        {{ $t("trading.need-account.btn") }}
    </NuxtLink>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useNuxtApp } from '#app';

const { locale } = useI18n();
const localPath = useLocalePath();
const { $regulationsVar } = useNuxtApp();

const config = {
  'default': {
    image: '/images/trading/NewTrading-Img.png',
  }
};

const currentRegulation = computed(() => $regulationsVar.getRegulation(locale.value));

const imageSrc = computed(() => {
  return config[locale.value]?.image || config[currentRegulation.value]?.image || config['default'].image;
});

const imageAlt = 'UX writer and stocks, forex';
</script>
